var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"id":"submitBtn","type":_vm.status ? 'button' : 'submit'}},[(!_vm.status)?_c('h2',[_vm._v(_vm._s(_vm.obj.title))]):_c('h2',{attrs:{"role":_vm.status ? 'status' : ''}},[_vm._v(_vm._s(_vm.obj.titlenext))])])
}
var staticRenderFns = []

export { render, staticRenderFns }